import { ILoginUser } from '../dtos/ILoginUser';

export enum CommandMenuType {
  User = 'User',
  General = 'General',
  Customer = 'Customer',
  Focus = 'Focus',
  Info = 'Info',
  Popular = 'Popular',
  LogOff = 'LogOff',
}

export interface ICommand {
  commandOrder: string;
  commandIcon: string;
  commandId: string;
  parameters?: IParameter[];
  states: IState[];
  checkRole?: boolean;
  userHasPermission?: boolean;
  allowOverride?: boolean;
  data?: ILoginUser;
}

export interface IParameter {
  name: string;
  value: string;
}

export interface IState {
  state: string;
  enabled: boolean;
}

export interface IPosUiMenu {
  menuType: CommandMenuType;
  commands: ICommand[]; // compare with ICommandMenuItem[]
}

export type IPosUiState = {
  [menuType in CommandMenuType]: IPosUiMenu;
};
